/* QWELL landing template interactivity: bundle selection, FAQ accordion, sticky mobile bar. */
(function () {
  function init() {
    initBundles();
    initFaq();
    initStickyBar();
  }

  function initBundles() {
    var form = document.getElementById('qwell-buy-form');
    var bundles = Array.prototype.slice.call(document.querySelectorAll('[data-qwell-bundle]'));
    if (!form || !bundles.length) return;
    var ptypes = Array.prototype.slice.call(document.querySelectorAll('[data-qwell-ptype]'));
    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('[data-qwell-qty]');
    var planInput = form.querySelector('[data-qwell-selling-plan]');
    var atcPriceEl = form.querySelector('[data-qwell-atc-price]');
    var onetimePriceEl = document.querySelector('[data-qwell-onetime-price]');
    var subPriceEl = document.querySelector('[data-qwell-sub-price-display]');

    var SELECTED_BTN = ['border-ocean', 'shadow-[var(--shadow-card)]'];
    var UNSELECTED_BTN = ['border-border', 'hover:border-ocean/50'];
    var SELECTED_RADIO = ['border-ocean', 'bg-ocean'];
    var UNSELECTED_RADIO = ['border-border'];

    function mark(group, target) {
      group.forEach(function (btn) {
        var on = btn === target;
        btn.setAttribute('data-selected', on ? 'true' : 'false');
        btn.classList.remove.apply(btn.classList, on ? UNSELECTED_BTN : SELECTED_BTN);
        btn.classList.add.apply(btn.classList, on ? SELECTED_BTN : UNSELECTED_BTN);
        var radio = btn.querySelector('.qwell-radio');
        if (radio) {
          radio.classList.remove.apply(radio.classList, on ? UNSELECTED_RADIO : SELECTED_RADIO);
          radio.classList.add.apply(radio.classList, on ? SELECTED_RADIO : UNSELECTED_RADIO);
        }
      });
    }

    function selected(group) {
      for (var i = 0; i < group.length; i++) {
        if (group[i].getAttribute('data-selected') === 'true') return group[i];
      }
      return group[0];
    }

    function refresh() {
      var bundle = selected(bundles);
      var subscribing =
        ptypes.length &&
        selected(ptypes).getAttribute('data-qwell-ptype') === 'subscribe' &&
        bundle.getAttribute('data-plan-id');

      if (idInput) idInput.value = bundle.getAttribute('data-variant-id');
      if (qtyInput) qtyInput.value = bundle.getAttribute('data-qty') || '1';
      if (planInput) {
        planInput.disabled = !subscribing;
        if (subscribing) planInput.value = bundle.getAttribute('data-plan-id');
      }
      if (onetimePriceEl) onetimePriceEl.textContent = bundle.getAttribute('data-price');
      if (subPriceEl && bundle.getAttribute('data-sub-price')) {
        subPriceEl.textContent = bundle.getAttribute('data-sub-price');
      }
      if (atcPriceEl) {
        atcPriceEl.textContent = subscribing
          ? bundle.getAttribute('data-sub-price')
          : bundle.getAttribute('data-price');
      }
    }

    // Submit through the AJAX API so the free gifts go in with the bottles.
    // The store's automatic "BUY X GET Y FREE QWELL + GIFTS" discounts only fire
    // once bottles + gifts are all in the cart (4 items for Buy 1, 6 for Buy 2).
    var giftIds = (form.getAttribute('data-qwell-gift-ids') || '')
      .split(',')
      .filter(function (id) { return id; });
    var submitBtn = form.querySelector('button[type="submit"]');

    form.addEventListener('submit', function (e) {
      if (!window.fetch || !giftIds.length) return; // fall back to normal form post
      e.preventDefault();
      refresh();

      var items = [{ id: Number(idInput.value), quantity: Number(qtyInput ? qtyInput.value : 1) }];
      if (planInput && !planInput.disabled && planInput.value) items[0].selling_plan = Number(planInput.value);
      giftIds.forEach(function (id) {
        items.push({ id: Number(id), quantity: 1 });
      });

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-busy', 'true');
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart add failed ' + res.status);
          window.location.href = '/cart';
        })
        .catch(function () {
          // Retry as a plain form post (bottles only) rather than leaving the user stuck.
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.removeAttribute('aria-busy');
          }
          form.submit();
        });
    });

    bundles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        mark(bundles, btn);
        refresh();
      });
    });
    ptypes.forEach(function (btn) {
      btn.addEventListener('click', function () {
        mark(ptypes, btn);
        refresh();
      });
    });
  }

  function initFaq() {
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-qwell-faq]'));
    items.forEach(function (item) {
      item.addEventListener('click', function () {
        var wasOpen = item.classList.contains('faq-open');
        items.forEach(function (other) {
          other.classList.remove('faq-open');
        });
        if (!wasOpen) item.classList.add('faq-open');
      });
    });
  }

  function initStickyBar() {
    var bar = document.getElementById('qwell-sticky-bar');
    var buy = document.getElementById('buy');
    if (!bar) return;

    var buyInView = false;
    if (buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        buyInView = entries[0].isIntersecting;
        update();
      }).observe(buy);
    }

    function update() {
      var show = window.scrollY > window.innerHeight * 0.6 && !buyInView;
      bar.classList.toggle('translate-y-full', !show);
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
